module.exports = __webpack_public_path__ + "files/e58cdf9e2a35447a0e616d8c19ad13fc.png";